import { render, staticRenderFns } from "./hotarea.vue?vue&type=template&id=6471de7a&scoped=true&"
import script from "./hotarea.vue?vue&type=script&lang=js&"
export * from "./hotarea.vue?vue&type=script&lang=js&"
import style0 from "./hotarea.vue?vue&type=style&index=0&id=6471de7a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6471de7a",
  null
  
)

export default component.exports